// extracted by mini-css-extract-plugin
export default {"form":"FirestoreMessageComposer_form__8NrKx"};